/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
/*  Geodesy representation conversion functions (c) Chris Veness 2002-2012                        */
/*   - www.movable-type.co.uk/scripts/latlong.html                                                */
/*                                                                                                */
/*  Sample usage:                                                                                 */
/*    var lat = Geo.parseDMS('51° 28′ 40.12″ N');                                                 */
/*    var lon = Geo.parseDMS('000° 00′ 05.31″ W');                                                */
/*    var p1 = new LatLon(lat, lon);                                                              */
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

(function(root) {
  'use strict';

  var Geo = {};  // Geo namespace, representing static class

  /**
   * Parses string representing degrees/minutes/seconds into numeric degrees
   *
   * This is very flexible on formats, allowing signed decimal degrees, or deg-min-sec optionally
   * suffixed by compass direction (NSEW). A variety of separators are accepted (eg 3º 37' 09"W) 
   * or fixed-width format without separators (eg 0033709W). Seconds and minutes may be omitted. 
   * (Note minimal validation is done).
   *
   * @param   {String|Number} dmsStr: Degrees or deg/min/sec in variety of formats
   * @returns {Number} Degrees as decimal number
   * @throws  {TypeError} dmsStr is an object, perhaps DOM object without .value?
   */
  Geo.parseDMS = function(dmsStr) {
    if (typeof deg == 'object') throw new TypeError('Geo.parseDMS - dmsStr is [DOM?] object');
    
    // check for signed decimal degrees without NSEW, if so return it directly
    if (typeof dmsStr === 'number' && isFinite(dmsStr)) return Number(dmsStr);
    
    // strip off any sign or compass dir'n & split out separate d/m/s
    var dms = String(dmsStr).trim().replace(/^-/,'').replace(/[NSEW]$/i,'').split(/[^0-9.,]+/);
    if (dms[dms.length-1]=='') dms.splice(dms.length-1);  // from trailing symbol
    
    if (dms == '') return NaN;
    
    // and convert to decimal degrees...
    switch (dms.length) {
      case 3:  // interpret 3-part result as d/m/s
        var deg = dms[0]/1 + dms[1]/60 + dms[2]/3600; 
        break;
      case 2:  // interpret 2-part result as d/m
        var deg = dms[0]/1 + dms[1]/60; 
        break;
      case 1:  // just d (possibly decimal) or non-separated dddmmss
        var deg = dms[0];
        // check for fixed-width unseparated format eg 0033709W
        //if (/[NS]/i.test(dmsStr)) deg = '0' + deg;  // - normalise N/S to 3-digit degrees
        //if (/[0-9]{7}/.test(deg)) deg = deg.slice(0,3)/1 + deg.slice(3,5)/60 + deg.slice(5)/3600; 
        break;
      default:
        return NaN;
    }
    if (/^-|[WS]$/i.test(dmsStr.trim())) deg = -deg; // take '-', west and south as -ve
    return Number(deg);
  };


  /**
   * Convert decimal degrees to deg/min/sec format
   *  - degree, prime, double-prime symbols are added, but sign is discarded, though no compass
   *    direction is added
   *
   * @private
   * @param   {Number} deg: Degrees
   * @param   {String} [format=dms]: Return value as 'd', 'dm', 'dms'
   * @param   {Number} [dp=0|2|4]: No of decimal places to use - default 0 for dms, 2 for dm, 4 for d
   * @returns {String} deg formatted as deg/min/secs according to specified format
   * @throws  {TypeError} deg is an object, perhaps DOM object without .value?
   */
  Geo.toDMS = function(deg, format, dp) {
    if (typeof deg == 'object') throw new TypeError('Geo.toDMS - deg is [DOM?] object');
    if (isNaN(deg)) return null;  // give up here if we can't make a number from deg
    
      // default values
    if (typeof format == 'undefined') format = 'dms';
    if (typeof dp == 'undefined') {
      switch (format) {
        case 'd': dp = 4; break;
        case 'dm': dp = 2; break;
        case 'dms': dp = 0; break;
        default: format = 'dms'; dp = 0;  // be forgiving on invalid format
      }
    }
    
    deg = Math.abs(deg);  // (unsigned result ready for appending compass dir'n)
    var dms;
    
    switch (format) {
      case 'd':
        d = deg.toFixed(dp);     // round degrees
        if (d<100) d = '0' + d;  // pad with leading zeros
        if (d<10) d = '0' + d;
        dms = d + '\u00B0';      // add º symbol
        break;
      case 'dm':
        var min = (deg*60).toFixed(dp);  // convert degrees to minutes & round
        var d = Math.floor(min / 60);    // get component deg/min
        var m = (min % 60).toFixed(dp);  // pad with trailing zeros
        if (d<100) d = '0' + d;          // pad with leading zeros
        if (d<10) d = '0' + d;
        if (m<10) m = '0' + m;
        dms = d + '\u00B0' + m + '\u2032';  // add º, ' symbols
        break;
      case 'dms':
        var sec = (deg*3600).toFixed(dp);  // convert degrees to seconds & round
        var d = Math.floor(sec / 3600);    // get component deg/min/sec
        var m = Math.floor(sec/60) % 60;
        var s = (sec % 60).toFixed(dp);    // pad with trailing zeros
        if (d<100) d = '0' + d;            // pad with leading zeros
        if (d<10) d = '0' + d;
        if (m<10) m = '0' + m;
        if (s<10) s = '0' + s;
        dms = d + '\u00B0' + m + '\u2032' + s + '\u2033';  // add º, ', " symbols
        break;
    }
    
    return dms;
  };


  /**
   * Convert numeric degrees to deg/min/sec latitude (suffixed with N/S)
   *
   * @param   {Number} deg: Degrees
   * @param   {String} [format=dms]: Return value as 'd', 'dm', 'dms'
   * @param   {Number} [dp=0|2|4]: No of decimal places to use - default 0 for dms, 2 for dm, 4 for d
   * @returns {String} Deg/min/seconds
   */
  Geo.toLat = function(deg, format, dp) {
    var lat = Geo.toDMS(deg, format, dp);
    return lat==null ? '–' : lat.slice(1) + (deg<0 ? 'S' : 'N');  // knock off initial '0' for lat!
  };


  /**
   * Convert numeric degrees to deg/min/sec longitude (suffixed with E/W)
   *
   * @param   {Number} deg: Degrees
   * @param   {String} [format=dms]: Return value as 'd', 'dm', 'dms'
   * @param   {Number} [dp=0|2|4]: No of decimal places to use - default 0 for dms, 2 for dm, 4 for d
   * @returns {String} Deg/min/seconds
   */
  Geo.toLon = function(deg, format, dp) {
    var lon = Geo.toDMS(deg, format, dp);
    return lon==null ? '–' : lon + (deg<0 ? 'W' : 'E');
  };


  /**
   * Convert numeric degrees to deg/min/sec as a bearing (0º..360º)
   *
   * @param   {Number} deg: Degrees
   * @param   {String} [format=dms]: Return value as 'd', 'dm', 'dms'
   * @param   {Number} [dp=0|2|4]: No of decimal places to use - default 0 for dms, 2 for dm, 4 for d
   * @returns {String} Deg/min/seconds
   */
  Geo.toBearing = function(deg, format, dp) {
    deg = (Number(deg)+360) % 360;  // normalise -ve values to 180º..360º
    var brng = Geo.toDMS(deg, format, dp);
    return brng==null ? '–' : brng.replace('360', '0');  // just in case rounding took us up to 360º!
  };


  // Add support for AMD, Node and plain JS
  if (typeof define === 'function' && define.amd) {
      define(Geo);
  } else if (typeof exports === 'object') {
      module.exports = Geo;
  } else {
      root.Geo = Geo;
  }

})(this);
